module.exports = __webpack_public_path__ + "img/logo-dentcloud-white.eb34278d.png";